<div class="td-wb-unsupported">
  <td-wb-icon class="td-wb-unsupported__massive-icon"
              size="70"
              iconId="warning" />
  <div class="td-wb-unsupported__header"
       translate="tdWb.unsupported.TITLE"></div>
  <div class="td-wb-unsupported__message-container">
    <div translate="tdWb.unsupported.MESSAGE2"></div>
  </div>
  <div class="td-wb-unsupported__links-container">
    <span [innerHTML]="'tdWb.unsupported.LINK' | translate: { url: 'link_supported_browsers' | tdWbHref, css: 'td-wb-link td-wb-link--underlined' }">
    </span>
    @if (to !== undefined) {
      <div class="td-wb-unsupported__link-spacer" translate="tdWb.unsupported.OR"></div>
      <a [tdWbHref]="to"
         [tdWbHrefParams]="params"
         class="td-wb-unsupported__link td-wb-unsupported__link-spacer">
        <span translate="tdWb.unsupported.CONTINUE"></span>
      </a>
    }
  </div>
</div>
